
$(document).ready(function(){
     setTimeout(() => {
          var getHeight = $('iframe body').height();
          console.log(getHeight);
     }, 1500);
});


$(document).ready(function(){
     setTimeout(()=>{
          $('a[href="https://monarchpowersports.recsystems.com/"], a[href="https://monarchpowersports.recsystems.com/"]',).attr('target','_blank');
     },500);
});


var swiper = new Swiper(".bannerSlider", {
      spaceBetween: 30,
      loop: true,
      effect: "fade",
       autoplay: {
          delay: 1000,
          disableOnInteraction: false,
     },
     pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
});


// Mouse / touch swipe autoplay stop
swiper.on('touchStart', function () {
    swiper.autoplay.stop();
});

swiper.on('slideChange', function () {
    swiper.autoplay.stop();
});

// ________ 1-Dec-2025 ________
// modal loading popup
{
     $('body').removeClass("no-scroll");
     $(document).on('click', '.close-sub-btn', function(){
          localStorage.setItem("loadpopup", "false");
     });
     var getitems = localStorage.getItem("loadpopup");
     if(getitems == 'false'){
          setTimeout(()=>{
               $('body').addClass("modalClose");
               $('body').removeClass("no-scroll");
          },100)
     }
}
// modal loading popup

var swiper = new Swiper(".mySwiper", {
      spaceBetween: 30,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    
    var swiper = new Swiper(".reviewSlider", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 100,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });